import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { closeIcon } from "../../../assetData/icons";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";
import SearchableDropdown from "../../ui/tableDataDropdowns/SearchableDropdown";

const EditTemplateBrokerMapping = ({
  data,
  buttonConfig,
  buttonClicked,
  brokerData,
  brokerLoading,
}) => {
  const editHandler = buttonConfig.editHandler;
  const closeHandler = buttonConfig.closePopup;

  const schema = z.object({
    template_id: z.number(),
    broker_template_id: z.number(),
    software_vendor_name: z.string().nonempty(),
    file_format: z.string().nonempty(),
    broker_id: z.number(),
    cnt_status: z.number(),
    bcnt_status: z.number(),
    cnt_is_deleted: z.number(),
    bcnt_is_deleted: z.number(),
  });

  console.log("data::::", data);

  const form = useForm({
    defaultValues: {
      template_id: data?.template_id,
      broker_template_id: data?.broker_template_id,
      software_vendor_name: data?.vendor_or_template_name,
      file_format: data?.file_format,
      broker_id: data?.broker_id,
      cnt_status: 1,
      bcnt_status: 1,
      cnt_is_deleted: 0,
      bcnt_is_deleted: 0,
      status: data?.status,
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const onSubmit = async (data) => {
    const res = await editHandler(data);
  };

  const onClose = () => {
    closeHandler();
  };

  const handleKey = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };
  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[700px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[30%] max-sm:top-[10%] lg:top-1/2 lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Update Template Broker Mapping
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="w-full pr-2 max-lg:max-h-[550px] lg:max-h-[400px] ">
            {/* row 1 */}
            <div className="gap-2 sm:flex max-sm:[&>div]:mt-4">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Template ID*</label>
                <input
                  placeholder="Type here"
                  type="number"
                  disabled
                  {...form.register("template_id")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.template_id && "border-[1px] border-red-300",
                  )}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={handleKey}
                />
              </div>
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">
                  Broker Template ID*
                </label>
                <input
                  placeholder="Type here"
                  type="number"
                  disabled
                  {...form.register("broker_template_id")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.broker_template_id && "border-[1px] border-red-300",
                  )}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={handleKey}
                />
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Broker Name*</label>
                <SearchableDropdown
                  data={brokerData}
                  valueKey={"id"}
                  displayKey={"name"}
                  filterKey={"id"}
                  setFilter={(val) => {
                    form.setValue("broker_id", val);
                  }}
                  defaultValue={form.watch("broker_id")}
                  editDefaultValue={(val) => form.setValue("broker_id", val)}
                  label={"Broker Name"}
                  type={"searchable"}
                  loading={brokerLoading}
                  className={"fixed z-[9999]"}
                />
              </div>
            </div>

            {/* row 2 */}
            <div className="gap-2 sm:mt-8 sm:flex max-sm:[&>div]:mt-4">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">File Format*</label>
                <select
                  {...form.register("file_format")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.file_format && "border-[1px] border-red-300",
                  )}
                >
                  <option value="">Select</option>
                  <option value="csv">CSV</option>
                  <option value="html">HTML</option>
                  <option value="pdf">PDF</option>
                  <option value="excel">XLSX</option>
                  <option value="zip">ZIP</option>
                </select>
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Vendor Name</label>
                <input
                  type="text"
                  step="any"
                  {...form.register("software_vendor_name")}
                  placeholder="Type here"
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.software_vendor_name &&
                      "border-[1px] border-red-300",
                  )}
                />
              </div>
              <div className={cn("flex w-full flex-col  gap-2")}></div>
            </div>
          </div>

          <div className="flex items-end justify-between gap-2 sm:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={buttonClicked}
              className={` ${
                buttonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {buttonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default EditTemplateBrokerMapping;
